// Sync active classes with radio button states on page load
function syncActiveClasses() {
  const subscriptionRadio = document.querySelector("#subscription");
  const buyOnceRadio = document.querySelector("#buyOnce");
  const subscriptionContainer = document.getElementById("subscriptionContainer-v2");
  const buyOnceContainer = document.getElementById("buyOnceContainer-v2");

  if (subscriptionRadio && buyOnceRadio && subscriptionContainer && buyOnceContainer) {
    // Remove all active classes first
    subscriptionContainer.classList.remove('active');
    buyOnceContainer.classList.remove('active');

    // Add active class to the container of the checked radio button
    if (subscriptionRadio.checked) {
      subscriptionContainer.classList.add('active');
    } else if (buyOnceRadio.checked) {
      buyOnceContainer.classList.add('active');
    }
  }
}

// Function to ensure subscription is selected by default
function setDefaultSubscription() {
  const subscriptionRadio = document.querySelector("#subscription");
  const buyOnceRadio = document.querySelector("#buyOnce");
  const subscriptionContainer = document.getElementById("subscriptionContainer-v2");
  const buyOnceContainer = document.getElementById("buyOnceContainer-v2");

  if (subscriptionRadio && buyOnceRadio && subscriptionContainer && buyOnceContainer) {
    // Set subscription as default if neither is explicitly checked
    if (!subscriptionRadio.checked && !buyOnceRadio.checked) {
      subscriptionRadio.checked = true;
    }

    // If subscription is available and not explicitly set to buy once, select subscription
    if (subscriptionRadio && !buyOnceRadio.checked) {
      subscriptionRadio.checked = true;
      buyOnceRadio.checked = false;
      subscriptionContainer.classList.add('active');
      buyOnceContainer.classList.remove('active');
    }
  }
}

// Run sync on page load and after a short delay to handle browser restoration
document.addEventListener('DOMContentLoaded', function() {
  setDefaultSubscription();
  syncActiveClasses();
});
window.addEventListener('load', function() {
  setDefaultSubscription();
  syncActiveClasses();
});
setTimeout(function() {
  setDefaultSubscription();
  syncActiveClasses();
}, 100);
setTimeout(function() {
  setDefaultSubscription();
  syncActiveClasses();
}, 500);

document.querySelector("#subscription").addEventListener("click", function(){
  onSubscriptionClick(false);
}, false);

document.querySelector("#buyOnce").addEventListener("click", function(){
  onSubscriptionClick(true);
}, false);

// Add change event listeners to radio buttons for direct sync
document.querySelector("#subscription").addEventListener("change", function(){
  if (this.checked) {
    syncActiveClasses();
  }
}, false);

document.querySelector("#buyOnce").addEventListener("change", function(){
  if (this.checked) {
    syncActiveClasses();
  }
}, false);

// Initialize default state - select subscription by default
setTimeout(function() {
  setDefaultSubscription();
  syncActiveClasses();
  // Only trigger subscription click if subscription is available and should be default
  const subscriptionRadio = document.querySelector("#subscription");
  if (subscriptionRadio) {
    onSubscriptionClick(false); // false = subscription selected
  }
}, 500)
function onSubscriptionClick(isBuyOnceClicked) {
  const subscriptionList = document.getElementById("appstle-widget-template");
  const buyOnce = document.getElementById("buyOnceContainer-v2");
  const subscriptionContainer = document.getElementById("subscriptionContainer-v2");
  const subscriptionRadio = document.querySelector("#subscription");
  const selectElement = document.getElementById('faux_select-otpions');
  const buyOnceRadio = document.querySelector("#buyOnce");
  const style = window.getComputedStyle(subscriptionList)

  const allSubscriptions = document.getElementsByClassName("appstle_input_wrapper")
  const priceElement = document.querySelector('.product-price--original[data-js-product-price-original]');
  const priceElementCustom = document.querySelector('.product-price--original-custom[data-js-product-price-original]');
  const metaPriceElement = document.querySelector('meta[property="og:price:amount_cents"]');
  const defaultPrice = parseFloat(metaPriceElement.getAttribute('content'));
  const appstleInputProperty = document.querySelector('input[id="appstle_selling_plan_property"]');

  if (!isBuyOnceClicked && style.getPropertyValue('display') == 'none') {
    // Subscription selected
    buyOnce.classList.remove('active');
    subscriptionContainer.classList.add('active');
    if (subscriptionRadio) subscriptionRadio.checked = true;
    if (buyOnceRadio) buyOnceRadio.checked = false;
    subscriptionList.style.display = "block";
    const newPrice = (defaultPrice * 0.90);
    priceElement.textContent = formatMoney(newPrice, KROWN.settings.shop_money_format_with_currency);
    priceElementCustom.textContent = formatMoney(newPrice, KROWN.settings.shop_money_format_with_currency);
    const selectedSelectOption = selectElement.options[selectElement.selectedIndex];
    const sellingPlanId = selectedSelectOption.getAttribute('data-id');
    //search the correct element from sellingPlanId from allSubscriptions and select it
    Array.from(allSubscriptions).find(el => {
      const currentInput = el.querySelector("input");
      if (currentInput.id == sellingPlanId){
        currentInput.checked = true;
      } else {
        currentInput.checked = false;
      }
    });
    if(appstleInputProperty) {
      appstleInputProperty.name = "properties[__appstle-selected-selling-plan]";
      appstleInputProperty.value = sellingPlanId;
    }
  } else {
    // Buy once selected
    subscriptionList.style.display = "none";
    buyOnce.classList.add('active');
    subscriptionContainer.classList.remove('active');
    if (buyOnceRadio) buyOnceRadio.checked = true;
    if (subscriptionRadio) subscriptionRadio.checked = false;
    allSubscriptions[0].getElementsByTagName("input")[0].click()
    priceElement.textContent = formatMoney(defaultPrice, KROWN.settings.shop_money_format_with_currency);
    priceElementCustom.textContent = formatMoney(defaultPrice, KROWN.settings.shop_money_format_with_currency);
    if(appstleInputProperty) {
      appstleInputProperty.name = "";
      appstleInputProperty.value = "";
    }
  }

  // Double-check sync after changes
  setTimeout(syncActiveClasses, 50);
}